import FirstPage from './FirstPage'
import {connect} from "react-redux";
import {getStyles, getOrder, managePreloader, languageChanged} from "../GlobalReduxState/action";

const mapDispatchToProps = (dispatch: any) => ({
    callGetStyles: (domainID: any,storeID:any, preview: boolean) => dispatch(getStyles(domainID, storeID, preview)), //funkcijos is action file
    callGetOrder: (domainId: any) => dispatch(getOrder(domainId)),
    showPreloader: (show: boolean) => dispatch(managePreloader(show)),
    languageChanged: (lng: string) => dispatch(languageChanged(lng)),
});

const mapStateToProps = (state: any) => ({
    loading: state.globalReducer.loading,
    order: state.globalReducer.order
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FirstPage);
